/**
 * video_start / video_progress / video_complete collector'i (opsiyonel).
 * HTML5 video elementlerini dinler; %25 adimlarinda progress gonderir.
 */
import { AUTO_EVENTS } from "../events";

const PROGRESS_MILESTONES = [25, 50, 75];

class MediaCollector {
    constructor(tracker) {
        this.tracker = tracker;
        // WeakSet: DOM'dan kalkan video (ve ona bağlı ayrık alt ağaç) GC'ye bırakılabilsin.
        // Düz dizi her videoyu sonsuza kadar tutuyordu; SPA'larda (ör. Supsis paneli) binlerce ayrık
        // DOM düğümü ve yok edilmiş bileşen bellekte kalıyordu (docs/cpanel-memory/CPANEL_MEMORY.md A16).
        this.tracked = typeof WeakSet === "function" ? new WeakSet() : null;
    }

    start() {
        this.bindExisting();
        this.observeNewNodes();
    }

    bindExisting() {
        const videos = document.querySelectorAll("video");
        for (let i = 0; i < videos.length; i++) this.bind(videos[i]);
    }

    /** Sonradan DOM'a eklenen videolar (SPA, lazy load) icin gozlemci. */
    observeNewNodes() {
        if (!window.MutationObserver || !document.body) return;
        const self = this;
        new MutationObserver(function (mutations) {
            for (let i = 0; i < mutations.length; i++) {
                const added = mutations[i].addedNodes || [];
                for (let j = 0; j < added.length; j++) {
                    const node = added[j];
                    if (!node || node.nodeType !== 1) continue;
                    if ((node.tagName || "").toLowerCase() === "video") {
                        self.bind(node);
                    } else if (node.firstElementChild && node.getElementsByTagName) {
                        // Yaprak düğümlerde arama yapma; getElementsByTagName querySelectorAll'dan ucuz.
                        const inner = node.getElementsByTagName("video");
                        for (let k = 0; k < inner.length; k++) self.bind(inner[k]);
                    }
                }
            }
        }).observe(document.body, { childList: true, subtree: true });
    }

    bind(video) {
        if (!video) return;
        if (this.tracked) {
            if (this.tracked.has(video)) return;
            this.tracked.add(video);
        } else {
            // WeakSet olmayan çok eski tarayıcılar: işaret öğenin üzerinde durur, referans tutulmaz.
            if (video.__supsisMediaTracked) return;
            video.__supsisMediaTracked = true;
        }

        const self = this;
        const state = { started: false, completed: false, sent: [] };

        const title = video.getAttribute("title") || video.getAttribute("aria-label") || "";
        const src = video.currentSrc || video.getAttribute("src") || "";

        const base = function () {
            return {
                video_title: String(title).slice(0, 120),
                video_src: String(src).slice(0, 300),
                video_duration: Math.round(video.duration || 0),
            };
        };

        video.addEventListener("play", function () {
            if (state.started) return;
            state.started = true;
            self.tracker.emit(AUTO_EVENTS.VIDEO_START, base());
        });

        video.addEventListener("timeupdate", function () {
            if (!video.duration || !isFinite(video.duration)) return;
            const percent = Math.round((video.currentTime / video.duration) * 100);
            for (let i = 0; i < PROGRESS_MILESTONES.length; i++) {
                const milestone = PROGRESS_MILESTONES[i];
                if (percent >= milestone && state.sent.indexOf(milestone) === -1) {
                    state.sent.push(milestone);
                    const props = base();
                    props.percent = milestone;
                    self.tracker.emit(AUTO_EVENTS.VIDEO_PROGRESS, props);
                }
            }
        });

        video.addEventListener("ended", function () {
            if (state.completed) return;
            state.completed = true;
            self.tracker.emit(AUTO_EVENTS.VIDEO_COMPLETE, base());
        });
    }
}

export default MediaCollector;



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/collectors/media.js
// module id = null
// module chunks = 